module.exports = __webpack_public_path__ + "static/media/non-classe.0f2d9a0d.webp";